import activityPanelStore from 'shared/store/activityPanelStore';

export type FeeType = 'feeOnTop' | 'feeOnly' | undefined;

export function useFeeType(): FeeType {
  const feeType = activityPanelStore((state) => state.feeType);
  return (feeType ?? undefined) as FeeType;
}
